import store from './store'
import utils from './utilities';
import route from './route'

let properties = {

    getErrorMessage(message) {

        /*The error messages have the following format -> "{error code} message"
        * so after the split messagePart[1] will be the error code and messagePart[2] will be the message both coming from back-end*/

        var messagePart = message.split(/{(.*)}/);
        var storeObj = {
            title: 'Σφάλμα!',
            color: 'error',
            class: 'white--text error text-center justify-center',
            icon:'error',
            successStyle:false,
            fontStyleBig:false
        };

        if(messagePart[1] === "not.authenticated") {
            store.commit('setloginModal', true);
            route.push({path: '/'});
            utils.deleteLocalStorage('token');
        }else if(messagePart[1] ==="pricing.error"){
            storeObj.text = messagePart[2];
            store.commit('setErrorPopup', true);
            store.commit('setErrorPopupProps', storeObj);
        }else if(messagePart[1] ==="error"){
            storeObj.text = messagePart[2];
            store.commit('setErrorPopup', true);
            store.commit('setErrorPopupProps', storeObj);
        }else if(messagePart[1] ==="error"){
            storeObj.text = messagePart[2];
            store.commit('setErrorPopup', true);
            store.commit('setErrorPopupProps', storeObj);
        }else if(messagePart[1] ==="remove.not.allowed"){
            storeObj.text = messagePart[2];
            store.commit('setErrorPopup', true);
            store.commit('setErrorPopupProps', storeObj);
        }
         else if(messagePart[1] ==="qnr.error"){
            storeObj.text = messagePart[2];
            store.commit('setErrorPopup', true);
            store.commit('setErrorPopupProps', storeObj);
        }
         else if(messagePart[1] === "not.authorized") {
            storeObj.text = messagePart[2];
            store.commit('setErrorPopup', true);
            store.commit('setErrorPopupProps', storeObj);
        }
        else if(messagePart[1] === "book.not.published") {
            storeObj.text = messagePart[2];
            store.commit('setErrorPopup', true);
            store.commit('setErrorPopupProps', storeObj);
        }
        else if(messagePart[1] === "dist.point.duplicate") {
            storeObj.text = messagePart[2];
            store.commit('setErrorPopup', true);
            store.commit('setErrorPopupProps', storeObj);
        }
        else if(messagePart[1] === "dist.point.period") {
            storeObj.text = messagePart[2];
            store.commit('setErrorPopup', true);
            store.commit('setErrorPopupProps', storeObj);
        }
        else if(messagePart[1] === "course.year.not.edited.year") {
            storeObj.text = messagePart[2];
            store.commit('setErrorPopup', true);
            store.commit('setErrorPopupProps', storeObj);
        }
        else if(messagePart[1] === "statements.exist") {
            storeObj.text = messagePart[2];
            store.commit('setErrorPopup', true);
            store.commit('setErrorPopupProps', storeObj);
        }
        else if(messagePart[1] === "dist.point.copy.period") {
            storeObj.text = messagePart[2];
            store.commit('setErrorPopup', true);
            store.commit('setErrorPopupProps', storeObj);
        }
        else if(messagePart[1] === "not.courier.active.period") {
            storeObj.text = messagePart[2];
            store.commit('setErrorPopup', true);
            store.commit('setErrorPopupProps', storeObj);
        }
        else if(messagePart[1] === "over.20.statementbooks") {
            storeObj.text = messagePart[2];
            store.commit('setErrorPopup', true);
            store.commit('setErrorPopupProps', storeObj);
        }
        else if(messagePart[1] === "no.statementbooks.selected") {
            storeObj.text = messagePart[2];
            store.commit('setErrorPopup', true);
            store.commit('setErrorPopupProps', storeObj);
        }
        else if(messagePart[1] === "no.state.got_voucher") {
            storeObj.text = messagePart[2];
            store.commit('setErrorPopup', true);
            store.commit('setErrorPopupProps', storeObj);
        }
        else if(messagePart[1] === "dist.point.exists") {
            storeObj.text = messagePart[2];
            store.commit('setErrorPopup', true);
            store.commit('setErrorPopupProps', storeObj);
        }
        else if(messagePart[1] === "date.expired") {
            storeObj.text = messagePart[2];
            store.commit('setErrorPopup', true);
            store.commit('setErrorPopupProps', storeObj);
        }
        else if(messagePart[1] === "order.missing") {
            storeObj.text = messagePart[2];
            store.commit('setErrorPopup', true);
            store.commit('setErrorPopupProps', storeObj);
        }
        else if(messagePart[1] === "order.not.removable") {
            storeObj.text = messagePart[2];
            store.commit('setErrorPopup', true);
            store.commit('setErrorPopupProps', storeObj);
        }
        else if(messagePart[1] === "order.status.not.completed") {
            storeObj.text = messagePart[2];
            store.commit('setErrorPopup', true);
            store.commit('setErrorPopupProps', storeObj);
        }
        else if(messagePart[1] === "order.status.not.completed.in.current.period") {
            storeObj.text = messagePart[2];
            store.commit('setErrorPopup', true);
            store.commit('setErrorPopupProps', storeObj);
        }
        else if(messagePart[1] === "order.status.not.pending_completed") {
            storeObj.text = messagePart[2];
            store.commit('setErrorPopup', true);
            store.commit('setErrorPopupProps', storeObj);
        }
        else if(messagePart[1] === "order.status.not.pending") {
            storeObj.text = messagePart[2];
            store.commit('setErrorPopup', true);
            store.commit('setErrorPopupProps', storeObj);
        }
        else if(messagePart[1] === "order.status.not.pending.in.current.year") {
            storeObj.text = messagePart[2];
            store.commit('setErrorPopup', true);
            store.commit('setErrorPopupProps', storeObj);
        }
        else if(messagePart[1] === "order.wrong.pin") {
            storeObj.text = messagePart[2];
            store.commit('setErrorPopup', true);
            store.commit('setErrorPopupProps', storeObj);
        }
        else if(messagePart[1] === "wrong.publisher.membership.attempt") {
            storeObj.text = messagePart[2];
            store.commit('setErrorPopup', true);
            store.commit('setErrorPopupProps', storeObj);
        }
        else if(messagePart[1] === "no.membership.period") {
            storeObj.text = messagePart[2];
            store.commit('setErrorPopup', true);
            store.commit('setErrorPopupProps', storeObj);
        }
        else if(messagePart[1] === "publisher.for.membership.not.found") {
            storeObj.text = messagePart[2];
            store.commit('setErrorPopup', true);
            store.commit('setErrorPopupProps', storeObj);
        }
        else if(messagePart[1] === "create.ePublished.book.not.allowed") {
            storeObj.text = messagePart[2];
            store.commit('setErrorPopup', true);
            store.commit('setErrorPopupProps', storeObj);
        }
        else if(messagePart[1] === "missing.book.id") {
            storeObj.text = messagePart[2];
            store.commit('setErrorPopup', true);
            store.commit('setErrorPopupProps', storeObj);
        }
        else if(messagePart[1] === "ebook.deletion.not.allowed") {
            storeObj.text = messagePart[2];
            store.commit('setErrorPopup', true);
            store.commit('setErrorPopupProps', storeObj);
        }
        else if(messagePart[1] === "secretariat.selected.files.deletion.not.allowed") {
            storeObj.text = messagePart[2];
            store.commit('setErrorPopup', true);
            store.commit('setErrorPopupProps', storeObj);
        }
        else if(messagePart[1] === "update.ePublished") {
            storeObj.text = messagePart[2];
            store.commit('setErrorPopup', true);
            store.commit('setErrorPopupProps', storeObj);
        }
        else if(messagePart[1] === "remove.price") {
            storeObj.text = messagePart[2];
            store.commit('setErrorPopup', true);
            store.commit('setErrorPopupProps', storeObj);
        }
        else if(messagePart[1] === "book.selected.after.kya") {
            storeObj.text = messagePart[2];
            store.commit('setErrorPopup', true);
            store.commit('setErrorPopupProps', storeObj);
        }
        else if(messagePart[1] === "book.selected.fek.price") {
            storeObj.text = messagePart[2];
            store.commit('setErrorPopup', true);
            store.commit('setErrorPopupProps', storeObj);
        }
        else if(messagePart[1] === "book.previous.selected.fek.price") {
            storeObj.text = messagePart[2];
            store.commit('setErrorPopup', true);
            store.commit('setErrorPopupProps', storeObj);
        }
        else if(messagePart[1] === "book.selected.in.edited.year") {
            storeObj.text = messagePart[2];
            store.commit('setErrorPopup', true);
            store.commit('setErrorPopupProps', storeObj);
        }
        else if(messagePart[1] === "book.locked") {
            storeObj.text = messagePart[2];
            store.commit('setErrorPopup', true);
            store.commit('setErrorPopupProps', storeObj);
        }
        else if(messagePart[1] === "book.type.different") {
            storeObj.text = messagePart[2];
            store.commit('setErrorPopup', true);
            store.commit('setErrorPopupProps', storeObj);
        }
        else if(messagePart[1] === "publisher.define.co-beneficiaries.not.allowed") {
            storeObj.text = messagePart[2];
            store.commit('setErrorPopup', true);
            store.commit('setErrorPopupProps', storeObj);
        }
        else if(messagePart[1] === "price.cap") {
            storeObj.text = messagePart[2];
            store.commit('setErrorPopup', true);
            store.commit('setErrorPopupProps', storeObj);
        }
        else if(messagePart[1] === "missing.info.kallipos") {
            storeObj.text = messagePart[2];
            store.commit('setErrorPopup', true);
            store.commit('setErrorPopupProps', storeObj);
        }
        else if(messagePart[1] === "secretariat.selected.book.deletion.not.allowed") {
            storeObj.text = messagePart[2];
            store.commit('setErrorPopup', true);
            store.commit('setErrorPopupProps', storeObj);
        }
        else if(messagePart[1] === "ebook.deletion.not.allowed") {
            storeObj.text = messagePart[2];
            store.commit('setErrorPopup', true);
            store.commit('setErrorPopupProps', storeObj);
        }
        else if(messagePart[1] === "not.last.edition.book.deletion.not.allowed") {
            storeObj.text = messagePart[2];
            store.commit('setErrorPopup', true);
            store.commit('setErrorPopupProps', storeObj);
        }
        else if(messagePart[1] === "not.last.edition.book.deletion.not.allowed") {
            storeObj.text = messagePart[2];
            store.commit('setErrorPopup', true);
            store.commit('setErrorPopupProps', storeObj);
        }
        else if(messagePart[1] === "invalid.webpage.format") {
            storeObj.text = messagePart[2];
            store.commit('setErrorPopup', true);
            store.commit('setErrorPopupProps', storeObj);
        }
        else if(messagePart[1] === "technical.pages.more.than.total") {
            storeObj.text = messagePart[2];
            store.commit('setErrorPopup', true);
            store.commit('setErrorPopupProps', storeObj);
        }
        else if(messagePart[1] === "colorfour.pages.more.than.total") {
            storeObj.text = messagePart[2];
            store.commit('setErrorPopup', true);
            store.commit('setErrorPopupProps', storeObj);
        }
        else if(messagePart[1] === "bad.request") {
            storeObj.text = messagePart[2];
            store.commit('setErrorPopup', true);
            store.commit('setErrorPopupProps', storeObj);
        }
        else if(messagePart[1] === "out.of.start.statementbook.courier") {
            storeObj.text = messagePart[2];
            store.commit('setErrorPopup', true);
            store.commit('setErrorPopupProps', storeObj);
        }
        else if(messagePart[1] === "out.of.cancel.statementbook.courier") {
            storeObj.text = messagePart[2];
            store.commit('setErrorPopup', true);
            store.commit('setErrorPopupProps', storeObj);
        }else if(messagePart[1] === "publisher.unknown.to.ACS") {
            storeObj.text = messagePart[2];
            store.commit('setErrorPopup', true);
            store.commit('setErrorPopupProps', storeObj);
        }
        else if(messagePart[1] === "remove.file.not.found") {
            storeObj.text = messagePart[2];
            store.commit('setErrorPopup', true);
            store.commit('setErrorPopupProps', storeObj);
        }
        else if(messagePart[1] === "pdf.only") {
            storeObj = {
                text: messagePart[2].split(".")[0],
            };
            store.commit('setErrorPopup', true);
            store.commit('setErrorPopupProps', storeObj);
        }
        else if(messagePart[1] === "parsing.error") {
            storeObj = {
                text: messagePart[2].split(".")[0],
            };
            store.commit('setErrorPopup', true);
            store.commit('setErrorPopupProps', storeObj);
        }
        else if(messagePart[1] === "upload.error") {
            storeObj = {
                text: messagePart[2].split(".")[0],
            };
            store.commit('setErrorPopup', true);
            store.commit('setErrorPopupProps', storeObj);
        }
        else if(messagePart[1] === "max.book.price.for.publishers") {
            storeObj.text = messagePart[2];
            store.commit('setErrorPopup', true);
            store.commit('setErrorPopupProps', storeObj);
        }
        else if(messagePart[1] === "co.beneficiaries.define") {
            storeObj.text = messagePart[2];
            store.commit('setErrorPopup', true);
            store.commit('setErrorPopupProps', storeObj);
        }
        else if(messagePart[1] === "unknown.publisher") {
            storeObj.text = messagePart[2];
            store.commit('setErrorPopup', true);
            store.commit('setErrorPopupProps', storeObj);
        }
        else if(messagePart[1] === "courier.auth.error") {
            storeObj.text = messagePart[2];
            store.commit('setErrorPopup', true);
            store.commit('setErrorPopupProps', storeObj);
        }
        else if(messagePart[1] === "{pdf.print.unsuccessful}") {
            storeObj.text = messagePart[2];
            store.commit('setErrorPopup', true);
            store.commit('setErrorPopupProps', storeObj);
        }
        else{
            storeObj.text = "Παρουσιάστηκε κάποιο σφάλμα στην επικοινωνία με το σύστημα. Πατήστε \"Ανανέωση\" στον browser και αν το πρόβλημα επιμείνει παρακαλώ επικοινωνήστε με το Γραφείο Αρωγής Χρηστών";
            store.commit('setErrorPopup', true);
            store.commit('setErrorPopupProps', storeObj);
        }
    }
};

export default properties